import type { IReport } from "@mctypes/report.types";
import type { PostProjectByProjectIdReportboardsAndReportIdFieldApiResponse as DirectReportResult } from "../../../../openapi";

export const getDirectReportVersion = (board: IReport.IReportBoardPopulated) =>
  [...(board.versions ?? [])].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0];

export const applyDirectReportResult = (board: IReport.IReportBoardPopulated, result: DirectReportResult) => {
  // Keep the actual draft version: getLatestVersionOfReport returns a deep copy.
  const version = getDirectReportVersion(board);
  if (version) version.data = structuredClone(result.data);
  board.revision = result.revision;
  board.updatedAt = result.updatedAt;
};
